// extracted by mini-css-extract-plugin
export default {"SendResetPasswordEmail":"SendResetPasswordEmail_SendResetPasswordEmail__A3LaL","SendResetPasswordEmail-actions":"SendResetPasswordEmail_SendResetPasswordEmail-actions__VRTLn"};